<template>
    <div class="main-page">
        <template v-if="showHeader">
            <section class="page-section mb-3" >
                <div class="container">
                    <div class="grid justify-content-between">
                        <div class="col " >
                            <div class="">
                                <div class=" text-2xl text-primary font-bold" >
                                    Edit Tickets
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </template>
        <section class="page-section " >
            <div class="container">
                <div class="grid ">
                    <div class="md:col-9 sm:col-12 comp-grid" >
                        <div class="">
                            <div class="">
                                <div >
                                    <template v-if="pageReady">
                                        <div class="grid">
                                            <div class="col-12">
                                                <form ref="observer"  tag="form" @submit.prevent="submitForm()" class="" :class="{ 'card': !isSubPage }">
                                                    <!--[form-content-start]-->
                                                    <div class="grid">
                                                        <div class="col-12">
                                                            <div class="formgrid grid">
                                                                <div class="col-12 md:col-3">
                                                                    Ticket Number 
                                                                </div>
                                                                <div class="col-12 md:col-9">
                                                                    <InputText ref="ctrlticket_number" v-model.trim="formData.ticket_number"  label="Ticket Number" type="text" placeholder="Enter Ticket Number"      
                                                                    class=" w-full" :class="getErrorClass('ticket_number')">
                                                                    </InputText>
                                                                    <small v-if="isFieldValid('ticket_number')" class="p-error">{{ getFieldError('ticket_number') }}</small> 
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-12">
                                                            <div class="formgrid grid">
                                                                <div class="col-12 md:col-3">
                                                                    Client Id 
                                                                </div>
                                                                <div class="col-12 md:col-9">
                                                                    <InputText ref="ctrlclient_id" v-model.trim="formData.client_id"  label="Client Id" type="number" placeholder="Enter Client Id"   step="any"    
                                                                    class=" w-full" :class="getErrorClass('client_id')">
                                                                    </InputText>
                                                                    <small v-if="isFieldValid('client_id')" class="p-error">{{ getFieldError('client_id') }}</small> 
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-12">
                                                            <div class="formgrid grid">
                                                                <div class="col-12 md:col-3">
                                                                    Title 
                                                                </div>
                                                                <div class="col-12 md:col-9">
                                                                    <InputText ref="ctrltitle" v-model.trim="formData.title"  label="Title" type="text" placeholder="Enter Title"      
                                                                    class=" w-full" :class="getErrorClass('title')">
                                                                    </InputText>
                                                                    <small v-if="isFieldValid('title')" class="p-error">{{ getFieldError('title') }}</small> 
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-12">
                                                            <div class="formgrid grid">
                                                                <div class="col-12 md:col-3">
                                                                    Severity *
                                                                </div>
                                                                <div class="col-12 md:col-9">
                                                                    <InputText ref="ctrlseverity" v-model.trim="formData.severity"  label="Severity" type="text" placeholder="Enter Severity"      
                                                                    class=" w-full" :class="getErrorClass('severity')">
                                                                    </InputText>
                                                                    <small v-if="isFieldValid('severity')" class="p-error">{{ getFieldError('severity') }}</small> 
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-12">
                                                            <div class="formgrid grid">
                                                                <div class="col-12 md:col-3">
                                                                    Assigned To 
                                                                </div>
                                                                <div class="col-12 md:col-9">
                                                                    <InputText ref="ctrlassigned_to" v-model.trim="formData.assigned_to"  label="Assigned To" type="number" placeholder="Enter Assigned To"   step="any"    
                                                                    class=" w-full" :class="getErrorClass('assigned_to')">
                                                                    </InputText>
                                                                    <small v-if="isFieldValid('assigned_to')" class="p-error">{{ getFieldError('assigned_to') }}</small> 
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-12">
                                                            <div class="formgrid grid">
                                                                <div class="col-12 md:col-3">
                                                                    Assigned District 
                                                                </div>
                                                                <div class="col-12 md:col-9">
                                                                    <InputText ref="ctrlassigned_district" v-model.trim="formData.assigned_district"  label="Assigned District" type="text" placeholder="Enter Assigned District"      
                                                                    class=" w-full" :class="getErrorClass('assigned_district')">
                                                                    </InputText>
                                                                    <small v-if="isFieldValid('assigned_district')" class="p-error">{{ getFieldError('assigned_district') }}</small> 
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-12">
                                                            <div class="formgrid grid">
                                                                <div class="col-12 md:col-3">
                                                                    Assigned Region 
                                                                </div>
                                                                <div class="col-12 md:col-9">
                                                                    <InputText ref="ctrlassigned_region" v-model.trim="formData.assigned_region"  label="Assigned Region" type="text" placeholder="Enter Assigned Region"      
                                                                    class=" w-full" :class="getErrorClass('assigned_region')">
                                                                    </InputText>
                                                                    <small v-if="isFieldValid('assigned_region')" class="p-error">{{ getFieldError('assigned_region') }}</small> 
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-12">
                                                            <div class="formgrid grid">
                                                                <div class="col-12 md:col-3">
                                                                    Complaint Type 
                                                                </div>
                                                                <div class="col-12 md:col-9">
                                                                    <InputText ref="ctrlcomplaint_type" v-model.trim="formData.complaint_type"  label="Complaint Type" type="text" placeholder="Enter Complaint Type"      
                                                                    class=" w-full" :class="getErrorClass('complaint_type')">
                                                                    </InputText>
                                                                    <small v-if="isFieldValid('complaint_type')" class="p-error">{{ getFieldError('complaint_type') }}</small> 
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-12">
                                                            <div class="formgrid grid">
                                                                <div class="col-12 md:col-3">
                                                                    Site Of Complaint 
                                                                </div>
                                                                <div class="col-12 md:col-9">
                                                                    <InputText ref="ctrlsite_of_complaint" v-model.trim="formData.site_of_complaint"  label="Site Of Complaint" type="text" placeholder="Enter Site Of Complaint"      
                                                                    class=" w-full" :class="getErrorClass('site_of_complaint')">
                                                                    </InputText>
                                                                    <small v-if="isFieldValid('site_of_complaint')" class="p-error">{{ getFieldError('site_of_complaint') }}</small> 
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-12">
                                                            <div class="formgrid grid">
                                                                <div class="col-12 md:col-3">
                                                                    Region 
                                                                </div>
                                                                <div class="col-12 md:col-9">
                                                                    <InputText ref="ctrlregion" v-model.trim="formData.region"  label="Region" type="text" placeholder="Enter Region"      
                                                                    class=" w-full" :class="getErrorClass('region')">
                                                                    </InputText>
                                                                    <small v-if="isFieldValid('region')" class="p-error">{{ getFieldError('region') }}</small> 
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-12">
                                                            <div class="formgrid grid">
                                                                <div class="col-12 md:col-3">
                                                                    Reg District 
                                                                </div>
                                                                <div class="col-12 md:col-9">
                                                                    <InputText ref="ctrlreg_district" v-model.trim="formData.reg_district"  label="Reg District" type="text" placeholder="Enter Reg District"      
                                                                    class=" w-full" :class="getErrorClass('reg_district')">
                                                                    </InputText>
                                                                    <small v-if="isFieldValid('reg_district')" class="p-error">{{ getFieldError('reg_district') }}</small> 
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-12">
                                                            <div class="formgrid grid">
                                                                <div class="col-12 md:col-3">
                                                                    Officer Handling 
                                                                </div>
                                                                <div class="col-12 md:col-9">
                                                                    <InputText ref="officer_handling" v-model.trim="formData.officer_handling"  label="Office Handling" type="text" placeholder="Enter Office Handling"      
                                                                    class=" w-full" :class="getErrorClass('officer_handling')">
                                                                    </InputText>
                                                                    <small v-if="isFieldValid('officer_handling')" class="p-error">{{ getFieldError('officer_handling') }}</small> 
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-12">
                                                            <div class="formgrid grid">
                                                                <div class="col-12 md:col-3">
                                                                    Source Of Complaint 
                                                                </div>
                                                                <div class="col-12 md:col-9">
                                                                    <InputText ref="ctrlsource_of_complaint" v-model.trim="formData.source_of_complaint"  label="Source Of Complaint" type="text" placeholder="Enter Source Of Complaint"      
                                                                    class=" w-full" :class="getErrorClass('source_of_complaint')">
                                                                    </InputText>
                                                                    <small v-if="isFieldValid('source_of_complaint')" class="p-error">{{ getFieldError('source_of_complaint') }}</small> 
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-12">
                                                            <div class="formgrid grid">
                                                                <div class="col-12 md:col-3">
                                                                    Action Taken 
                                                                </div>
                                                                <div class="col-12 md:col-9">
                                                                    <InputText ref="ctrlaction_taken" v-model.trim="formData.action_taken"  label="Action Taken" type="text" placeholder="Enter Action Taken"      
                                                                    class=" w-full" :class="getErrorClass('action_taken')">
                                                                    </InputText>
                                                                    <small v-if="isFieldValid('action_taken')" class="p-error">{{ getFieldError('action_taken') }}</small> 
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-12">
                                                            <div class="formgrid grid">
                                                                <div class="col-12 md:col-3">
                                                                    Description 
                                                                </div>
                                                                <div class="col-12 md:col-9">
                                                                    <Textarea :class="getErrorClass('description')" class="w-full" ref="ctrldescription" rows="5"  v-model="formData.description" placeholder="Enter Description"    type="textarea">
                                                                    </Textarea>
                                                                    <small v-if="isFieldValid('description')" class="p-error">{{ getFieldError('description') }}</small> 
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-12">
                                                            <div class="formgrid grid">
                                                                <div class="col-12 md:col-3">
                                                                    Solution 
                                                                </div>
                                                                <div class="col-12 md:col-9">
                                                                    <Textarea :class="getErrorClass('solution')" class="w-full" ref="ctrlsolution" rows="5"  v-model="formData.solution" placeholder="Enter Solution"    type="textarea">
                                                                    </Textarea>
                                                                    <small v-if="isFieldValid('solution')" class="p-error">{{ getFieldError('solution') }}</small> 
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-12">
                                                            <div class="formgrid grid">
                                                                <div class="col-12 md:col-3">
                                                                    Status 
                                                                </div>
                                                                <div class="col-12 md:col-9">
                                                                    <InputText ref="ctrlstatus" v-model.trim="formData.status"  label="Status" type="text" placeholder="Enter Status"      
                                                                    class=" w-full" :class="getErrorClass('status')">
                                                                    </InputText>
                                                                    <small v-if="isFieldValid('status')" class="p-error">{{ getFieldError('status') }}</small> 
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-12">
                                                            <div class="formgrid grid">
                                                                <div class="col-12 md:col-3">
                                                                    Customer Id 
                                                                </div>
                                                                <div class="col-12 md:col-9">
                                                                    <InputText ref="ctrlcustomer_id" v-model.trim="formData.customer_id"  label="Customer Id" type="number" placeholder="Enter Customer Id"   step="any"    
                                                                    class=" w-full" :class="getErrorClass('customer_id')">
                                                                    </InputText>
                                                                    <small v-if="isFieldValid('customer_id')" class="p-error">{{ getFieldError('customer_id') }}</small> 
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-12">
                                                            <div class="formgrid grid">
                                                                <div class="col-12 md:col-3">
                                                                    Created By 
                                                                </div>
                                                                <div class="col-12 md:col-9">
                                                                    <InputText ref="ctrlcreated_by" v-model.trim="formData.created_by"  label="Created By" type="number" placeholder="Enter Created By"   step="any"    
                                                                    class=" w-full" :class="getErrorClass('created_by')">
                                                                    </InputText>
                                                                    <small v-if="isFieldValid('created_by')" class="p-error">{{ getFieldError('created_by') }}</small> 
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-12">
                                                            <div class="formgrid grid">
                                                                <div class="col-12 md:col-3">
                                                                    Is Deleted 
                                                                </div>
                                                                <div class="col-12 md:col-9">
                                                                    <InputText ref="ctrlis_deleted" v-model.trim="formData.is_deleted"  label="Is Deleted" type="text" placeholder="Enter Is Deleted"      
                                                                    class=" w-full" :class="getErrorClass('is_deleted')">
                                                                    </InputText>
                                                                    <small v-if="isFieldValid('is_deleted')" class="p-error">{{ getFieldError('is_deleted') }}</small> 
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <!--[form-content-end]-->
                                                    <div v-if="showSubmitButton" class="text-center my-3">
                                                        <Button type="submit" label="Update" icon="pi pi-send" :loading="saving" />
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                    </template>
                                    <template v-if="loading">
                                        <div class="p-3 text-center">
                                            <ProgressSpinner style="width:50px;height:50px" />
                                        </div>
                                    </template>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>
<script setup>
	import {  computed,  reactive, toRefs, onMounted } from 'vue';
	import useVuelidate from '@vuelidate/core';
	import { required, numeric, } from '@/services/validators';
	import { useApp } from '@/composables/app.js';
	import { useEditPage } from '@/composables/editpage.js';
	const props = defineProps({
		id: [String, Number],
		pageName: {
			type: String,
			default: 'tickets',
		},
		routeName: {
			type: String,
			default: 'ticketsedit',
		},
		pagePath: {
			type : String,
			default : 'tickets/edit',
		},
		apiPath: {
			type: String,
			default: 'tickets/edit',
		},
		submitButtonLabel: {
			type: String,
			default: "Update",
		},
		formValidationError: {
			type: String,
			default: "Form is invalid",
		},
		formValidationMsg: {
			type: String,
			default: "Please complete the form",
		},
		msgAfterUpdate: {
			type: String,
			default: "Record updated successfully",
		},
		showHeader: {
			type: Boolean,
			default: true,
		},
		showSubmitButton: {
			type: Boolean,
			default: true,
		},
		redirect: {
			type : Boolean,
			default : true,
		},
		isSubPage: {
			type : Boolean,
			default : false,
		},
	});
	const app = useApp();
	const formDefaultValues = Object.assign({
		ticket_number: "", 
		client_id: "", 
		title: "", 
		severity: "Low", 
		assigned_to: "", 
		assigned_district: "", 
		assigned_region: "None", 
		complaint_type: "", 
		site_of_complaint: "", 
		region: "", 
		reg_district: "", 
		officer_handling: "", 
		source_of_complaint: "", 
		action_taken: "", 
		description: "", 
		solution: "", 
		status: "", 
		customer_id: "", 
		created_by: "", 
		is_deleted: "", 
	}, props.pageData);
	const formData = reactive({ ...formDefaultValues });
	function onFormSubmited(response) {
		app.flashMsg(props.msgAfterUpdate);
		if(props.redirect) app.navigateTo(`/tickets`);
	}
	const rules = computed(() => {
		return {
			ticket_number: {  },
			client_id: { numeric },
			title: {  },
			severity: { required },
			assigned_to: { numeric },
			assigned_district: {  },
			assigned_region: {  },
			complaint_type: {  },
			site_of_complaint: {  },
			region: {  },
			reg_district: {  },
			officer_handling: {  },
			source_of_complaint: {  },
			action_taken: {  },
			description: {  },
			solution: {  },
			status: {  },
			customer_id: { numeric },
			created_by: { numeric },
			is_deleted: {  }
		}
	});
	const v$ = useVuelidate(rules, formData); //form validation
	const page = useEditPage(props, formData, v$, onFormSubmited);
	//page state
	const {
		submitted, // form api submitted state - Boolean
		saving, // form api submiting state - Boolean
		loading, // form data loading state - Boolean
		pageReady, // if api data loaded successfully
	} = toRefs(page.state);
	//page computed propties
	const {
		apiUrl, // page current api path
		currentRecord, // current page record  - Object
	} = page.computedProps
	//page methods
	const { 
		load, // get editable form data from api
		submitForm, // submit form data to api
		getErrorClass, // return error class if field is invalid- args(fieldname)
		getFieldError, //  get validation error message - args(fieldname)
		isFieldValid, // check if field is validated - args(fieldname)
		 // map api datasource  to Select options label-value
	} = page.methods;
	onMounted(()=>{
		const pageTitle = "Edit Tickets";
		app.setPageTitle(props.routeName, pageTitle); // set browser page title
		load();
	});
</script>
<style scoped>
</style>
